$(document).ready(function(){
    
  let tabNavItems = document.querySelectorAll('.js-coll-tab-nav-item');
  let tabContents = document.querySelectorAll('.js-coll-tab-content');
  let tabNavItemsMob = document.querySelectorAll('.js-coll-tab-nav-item-mob');
  let tabContentsMob = document.querySelectorAll('.js-coll-tab-content-mob');
  

  tabNavItems[0].classList.add('is-active');
  tabContents[0].classList.add('is-active');

  tabNavItemsMob[0].classList.add('is-active');
  tabContentsMob[0].classList.add('is-active');
  
  
  tabNavItems.forEach(tabNavItem => {
     tabNavItem.addEventListener('click', () => {
    
  
    if(!tabNavItem.classList.contains('is-active')) {
      tabNavItems.forEach(element => {element.classList.remove('is-active');})
      tabContents.forEach(element => {element.classList.remove('is-active');})
  
      let selectedTabContent = document.querySelector('.js-coll-tab-content[data-index="' + tabNavItem.dataset.index + '"]');
      
      
      tabNavItem.classList.add('is-active');
      selectedTabContent.classList.add('is-active');
    }
  })
  })

  tabNavItemsMob.forEach(tabNavItemMob => {
    tabNavItemMob.addEventListener('click', () => {
   
 
   if(!tabNavItemMob.classList.contains('is-active')) {
    tabNavItemsMob.forEach(element => {element.classList.remove('is-active');})
    tabContentsMob.forEach(element => {element.classList.remove('is-active');})
 
     let selectedTabContentMob = document.querySelector('.js-coll-tab-content-mob[data-index="' + tabNavItemMob.dataset.index + '"]');
     
     
     tabNavItemMob.classList.add('is-active');
     selectedTabContentMob.classList.add('is-active');
   }
 })
 })
  
})
